import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Branch, BranchState } from "@/types/organization";

const initialState: BranchState = {
  branches: [],
  branch: null,
};

export const branchSlice = createSlice({
  name: "branches",
  initialState,
  reducers: {
    addBranch: (state, action: PayloadAction<Branch>) => {
      const newBranch: Branch = {
        ...action.payload,
      };
      state.branches.push(newBranch);
    },
    setBranch: (state, action: PayloadAction<Branch>) => {
      state.branch = action.payload;
    },

    setBranches: (state, action: PayloadAction<Branch[]>) => {
      state.branches = action.payload;
    },
    updatedBranch: (state, action: PayloadAction<Branch>) => {
      const index = state.branches.findIndex(
        (branch) => branch.id === action.payload.id,
      );
      if (index !== -1) {
        Object.assign(state.branches[index], action.payload);
      }
    },

    deleteBranch: (state, action: PayloadAction<number>) => {
      state.branches = state.branches.filter(
        (branch) => branch.id !== action.payload,
      );
    },
  },
});

export const {
  addBranch,
  setBranch,
  updatedBranch,
  deleteBranch,
  setBranches,
} = branchSlice.actions;

export default branchSlice.reducer;
